import * as React from 'react';

export type DeprecationWarning<T extends {}> = {
  prop: keyof T;
  message: string;
  predicate?: (prop: T[keyof T]) => boolean;
};

export function withDeprecationWarnings<Props extends {}>(
  Component: React.ComponentType<Props>,
  deprecationWarnings: DeprecationWarning<Props>[],
  logger?: (...args: unknown[]) => void
) {
  const displayName = Component.displayName || 'Component';
  const logFn = logger || console.warn;

  const warn = (message: string, componentName: string) => {
    logFn(
      '🍊🍊🍊🍊🍊🍊🍊🍊🍊🍊🍊🍊',
      '\n',
      `CITRUS DEPRECATION WARNING: ${componentName} - ${message}`,
      '\n',
      '🍊🍊🍊🍊🍊🍊🍊🍊🍊🍊🍊🍊'
    );
  };

  return function wrappedComponent(props: Props) {
    if (process.env.NODE_ENV === 'production') return <Component {...props} />;

    deprecationWarnings.forEach(({ prop, message, predicate }) => {
      const testFn =
        predicate || ((p: Props[keyof Props]) => typeof p !== 'undefined');

      if (testFn(props[prop])) {
        warn(message, displayName);
      }
    });

    return <Component {...props} />;
  };
}
